export default __webpack_public_path__ + "static/media/google-symbol.1c87ab6c.svg";